import React from 'react'
import Todo from '../components/Todo'
import Todotask from '../components/Todotask'

const Todoscreen = () => {
  return (
    <>
    <Todo/>
    
    </>
  )
}

export default Todoscreen
